export default function SistemaContextoManager(
  $q,
  $rootScope,
  acessoService,
  acessoContextoHolder,
  entidadeContextoHolderService,
  userAccessContext,
  appContextoService
) {

  const getApplicationContext = () => {
    return 'SistemaContextoHolderService';
  };

  const resolve = (idSistema) => {
    const contextoAtual = entidadeContextoHolderService.get();

    return acessoService.getSistemasByEntidade(contextoAtual.values.entity).then((sistemas) => {
      const sistema = _.find(sistemas, sistema => sistema.id == idSistema);
      if (!sistema) {
        return $q.reject();
      }

      return acessoService.meusAcessos().then((acessos) => {
        const acessoSistema = _.find(acessos, acesso =>
          acesso.system == sistema.id && acesso.values.entity == contextoAtual.values.entity
        );

        $rootScope.$emit('gerenciador.acessos.sistema.selecionado', { sistema: sistema });

        acessoContextoHolder.put(acessos);
        userAccessContext.setUserAccess(acessoSistema);
        appContextoService.setAppContext(acessoSistema);

        return sistema;
      });
    });
  };

  return {
    getApplicationContext: getApplicationContext,
    resolve: resolve
  }
}

SistemaContextoManager.$inject = [
  '$q',
  '$rootScope',
  'AcessoService',
  'AcessoContextoHolderService',
  'EntidadeContextoHolderService',
  'UserAccessContext',
  'AppContextService'
];

